export const environment = {
  production: true,
  name: 'qual',
  languages: {
    availables: [
      'en-EN'
    ],
    default: 'en-EN'
  },
  aws: {
    amplify: {
      aws_user_pools_id: 'eu-west-1_diRXLFgIy',
      aws_user_pools_web_client_id: '700v56nk2mts3kv21ctifvp3sl',
      API: {
        REST: 'https://carelflex-qual-iconfig-api.arkema.com/qual/'
      }
    },
    oauth: {
      domain: 'carelflex-qual-iconfig.auth.eu-west-1.amazoncognito.com',
      scope: ['aws.cognito.signin.user.admin', 'openid'],
      redirectSignIn: 'https://config-carelflex-qual.arkemacloud.com/login',
      redirectSignOut: 'https://config-carelflex-qual.arkemacloud.com/login',
      responseType: 'code'
    }
  }
};
